import { camelizedJSONFetch } from '../fetchShim';
import type { GetProcessingFeesRequestParams, GetProcessingFeesResponse } from './types';
import { GET_PROCESSING_FEES_PATH } from './constants';

export const getProcessingFees = async ({ merchantToken }: GetProcessingFeesRequestParams) => {
  const queryParams = new URLSearchParams({
    merchant_token: merchantToken,
  });
  return camelizedJSONFetch<GetProcessingFeesResponse>(
    `${GET_PROCESSING_FEES_PATH}?${queryParams.toString()}`,
    { method: 'GET' },
  );
};
